'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: function root(overrideStyle) {
    return (0, _combineStyles2.default)(_styles2.default.root, overrideStyle);
  },
  listHeader: function listHeader(overrideStyle) {
    return (0, _combineStyles2.default)(_styles2.default.listHeader, overrideStyle);
  },
  list: function list(header, enableInfiniteScroll, overrideStyle) {
    var style = _styles2.default.list;

    if (header) {
      style = (0, _combineStyles2.default)(style, { height: 'calc(100% - 36px)' });
    }

    if (enableInfiniteScroll) {
      style = (0, _combineStyles2.default)(style, { overflowY: 'hidden' });
    }

    return (0, _combineStyles2.default)(style, overrideStyle);
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/list/get-styles.js
// module id = 893
// module chunks = 0